import React, { useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import api from '../apis/api';
import style from './stylesheets/Card.module.css';
import Loader from './Loader';

import { userContext } from '../App';

const Card = (props) => {
    const history = useHistory();
    const {dispatch} = useContext(userContext);
    const [loader,setLoader] = useState(true);

    const discount = (oprice,dprice) =>{
        let percent = oprice - dprice;
        percent = (percent / oprice *100)+1;
        return parseInt(percent);
    }

    const text = (text) =>{
        if(text.length>23){
            text = text.slice(0,21)+'....';
            return text;
        }else{
            return text;
        }
    }
    const des = (data) =>{
        // console.log(typeof(data));
        if(!data || data == null || data === '' || data.length <= 0){
            return 'N/A';
        }else if(typeof(data) == 'object'){
            return data.join(', ');
        }else{
            return data;
        }
    }

    const Handelclick = async (e) =>{
        try {
            setLoader(false);
            const response = await api.get('/checkout');
            const data = await response.data.status;
            // console.log(data);

            if(data){
                await api.post('/checkout',{cart:e.target.value});
                dispatch({type:"USER",payload:true})
                setLoader(true);
                history.push('/checkout');
            }
        } catch (error) {
            dispatch({type:"USER",payload:false})
            history.push('/login');
        }
    }
    const addCart = async (e) =>{
        try {
            e.target.innerText="Adding ...";
            e.target.style = "background-color:red"
            const response = await api.get('/checkout');
            const data = await response.data.status;
            if(data){
                try{
                    const response = await api.post('/checkout',{cart:e.target.value});
                    const data = response.data;
                    console.log(data);
                    e.target.innerText="Added"
                    e.target.style = "background-color:green";
                }catch(err){
                    console.log(err);
                }
            }
        } catch (error) {
            dispatch({type:"USER",payload:false})
            history.push('/login');
        }   
    }
useEffect(() => {
    
}, [])
    return (
        <>
        {loader ? 
        <div key={props.index} className={style.card} >
            <img src={`data:${props.productImage.contentType};base64,${props.productImage.imageBase64}`} alt="productImage" />
            <div className={style.data}>
                <h4 title={props.productName}>{text(props.productName)}</h4>       
                <p>color: {des(props.colorOption)}</p>  
                <h3>₹{props.discountAmount} <del className={style.del}>₹{props.amount} </del><span className={style.span}>{discount(props.amount,props.discountAmount)}% off</span></h3>   
                <p>Availabel size: {des(props.size)}</p>
                {/* {props.size !== null ? (props.size.length>0 ? <select name='size'>
                    <option value="N/A" selected>Choose yours</option>
                {
                    props.size.map((val)=>{
                        return(
                            <option value={val}>{val}</option>
                        )
                    })
                }</select>: <p></p>):<p></p>} */}
                <div className={style.buttonaction}>
                <button value={props._id} style={{backgroundColor:'aqua'}} onClick={addCart}>Add to cart</button>   
                <button value={props._id} onClick={Handelclick}>buy now</button>  
                </div>
            </div>
        </div>
        : <Loader/> }
        </>
        
    )
}

export default Card ;
